// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnPrev {
  width: 70px !important;
  min-width: 70px !important;
}

.btnNext {
  width: 70px !important;
  min-width: 70px !important;
}

.outer {
  border: solid 3px;
  border-color: var(--ion-color-secondary-tint);
  max-width: 500px !important;
  border-radius: 15px !important;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff !important;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  align-items: center;
}

.ion-text-start {
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

#errortext {
  float: left;
  padding-left: 16px;
  color: var(--ion-color-danger) !important;
}

.redborder {
  border-color: var(--ion-color-danger) !important;
  border-radius: 15px !important;
}

.greenborder {
  border-color: var(--ion-color-success) !important;
  border-width: 3px !important;
  border-radius: 15px !important;
}

.extrapad {
  padding-bottom: 22px;
}

ion-item {
  border-width: 3px !important;
}

ion-select {
  border: solid 1px;
  border-color: var(--ion-color-light);
}

.showpointer {
  cursor: pointer;
}

.remove:hover {
  background: var(--ion-color-danger-shade);
  color: var(--ion-color-medium-contrast);
  transition: background 0.1s, color 0.1s;
}

.remove {
  border-radius: 1rem;
  color: var(--ion-color-danger);
  transition: background 0.5s, color 0.5s;
}

ion-input {
  border: none !important;
  width: 100% !important;
}

.bullets {
  margin: 0 !important;
  position: absolute !important;
  top: -200% !important;
}
.bullets .swiper-pagination {
  left: 50% !important;
  transform: translateX(-50%) !important;
}
.bullets .swiper-pagination-bullet {
  margin: 3px;
}

ion-select {
  border-radius: 15px !important;
}

ion-icon {
  padding-right: 16px !important;
}

.furtherJobObject {
  border-style: solid;
  border-width: 3px;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-bottom: 15px;
  border-color: #ffde70;
}

ion-select {
  height: 55px;
  border-width: 3px !important;
}

.nicebg {
  background-image: linear-gradient(138deg, rgb(255, 194, 0) 0%, rgb(255, 194, 0) 35%, rgb(255, 200, 34) 100%);
}

.standardbutton {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 0px;
}

ion-grid {
  padding-bottom: 0px;
  margin-bottom: 0px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/taxdetails-form/taxdetails-form.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,0BAAA;AACF;;AACA;EACE,sBAAA;EACA,0BAAA;AAEF;;AACA;EACE,iBAAA;EACA,6CAAA;EACA,2BAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAEF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;AAFF;;AAIA;EACE,gDAAA;EACA,8BAAA;AADF;;AAGA;EACE,iDAAA;EACA,4BAAA;EACA,8BAAA;AAAF;;AAEA;EACE,oBAAA;AACF;;AACA;EACE,4BAAA;AAEF;;AAAA;EACE,iBAAA;EACA,oCAAA;AAGF;;AADA;EACE,eAAA;AAIF;;AAFA;EACE,yCAAA;EACA,uCAAA;EACA,uCAAA;AAKF;;AAHA;EACE,mBAAA;EACA,8BAAA;EACA,uCAAA;AAMF;;AAJA;EACE,uBAAA;EACA,sBAAA;AAOF;;AALA;EACE,oBAAA;EACA,6BAAA;EACA,qBAAA;AAQF;AAPE;EACE,oBAAA;EACA,sCAAA;AASJ;AAPE;EACE,WAAA;AASJ;;AANA;EACE,8BAAA;AASF;;AAPA;EACE,8BAAA;AAUF;;AAPA;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AAUF;;AARA;EACE,YAAA;EACA,4BAAA;AAWF;;AATA;EACE,4GAAA;AAYF;;AAJA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;AAOF;;AAJA;EACE,mBAAA;EACA,kBAAA;AAOF;AACA,wlJAAwlJ","sourcesContent":[".btnPrev {\n  width: 70px !important;\n  min-width: 70px !important;\n}\n.btnNext {\n  width: 70px !important;\n  min-width: 70px !important;\n}\n\n.outer {\n  border: solid 3px;\n  border-color: var(--ion-color-secondary-tint);\n  max-width: 500px !important;\n  border-radius: 15px !important;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: #ffffff !important;\n  padding-left: 15px;\n  padding-right: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.ion-text-start {\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.topzero {\n  // top: 10px !important;\n}\n\n#errortext {\n  float: left;\n  padding-left: 16px;\n  color: var(--ion-color-danger) !important;\n}\n.redborder {\n  border-color: var(--ion-color-danger) !important;\n  border-radius: 15px !important;\n}\n.greenborder {\n  border-color: var(--ion-color-success) !important;\n  border-width: 3px !important;\n  border-radius: 15px !important;\n}\n.extrapad {\n  padding-bottom: 22px;\n}\nion-item {\n  border-width: 3px !important;\n}\nion-select {\n  border: solid 1px;\n  border-color: var(--ion-color-light);\n}\n.showpointer {\n  cursor: pointer;\n}\n.remove:hover {\n  background: var(--ion-color-danger-shade);\n  color: var(--ion-color-medium-contrast);\n  transition: background 0.1s, color 0.1s;\n}\n.remove {\n  border-radius: 1rem;\n  color: var(--ion-color-danger);\n  transition: background 0.5s, color 0.5s;\n}\nion-input {\n  border: none !important;\n  width: 100% !important;\n}\n.bullets {\n  margin: 0 !important;\n  position: absolute !important;\n  top: -200% !important;\n  .swiper-pagination {\n    left: 50% !important;\n    transform: translateX(-50%) !important;\n  }\n  .swiper-pagination-bullet {\n    margin: 3px;\n  }\n}\nion-select {\n  border-radius: 15px !important;\n}\nion-icon {\n  padding-right: 16px !important;\n}\n\n.furtherJobObject {\n  border-style: solid;\n  border-width: 3px;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  padding-bottom: 15px;\n  border-color: #ffde70;\n}\nion-select {\n  height: 55px;\n  border-width: 3px !important;\n}\n.nicebg {\n  background-image: linear-gradient(\n    138deg,\n    rgba(255, 194, 0, 1) 0%,\n    rgba(255, 194, 0, 1) 35%,\n    rgb(255, 200, 34) 100%\n  );\n}\n\n.standardbutton {\n  width: 100%;\n  margin-bottom: 10px;\n  margin-top: 0px;\n}\n\nion-grid {\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
